import { isMobileDevice, isTabletDevice, Translate, useBoolean } from '@dreryk/react-common';
import {
   Button,
   ButtonVariant,
   Link,
   MobilePhoneIcon,
   Modal,
   ModalCloseButton,
   ModalWidth,
   Separator,
   StyledFlex,
   Text,
} from '@dreryk/react-components';

import { mobileVersionAvailableModalTranslationKeys } from '../../translations';

import { StyledButtons, StyledContent } from './MobileVersionAvailableModal.styled';

const t = mobileVersionAvailableModalTranslationKeys;

export const MobileVersionAvailableModal = (): JSX.Element => {
   const { mobileWebsiteUrl } = window.APP_ENV;
   const [{ setFalse: closeModal }, modalOpened] = useBoolean(true);
   const shouldShowModal = isMobileDevice() || isTabletDevice();

   if (!mobileWebsiteUrl || !shouldShowModal || !modalOpened) {
      return <></>;
   }

   return (
      <Modal
         testId={'mobileVersionAvailable'}
         title={t.title}
         width={isTabletDevice() ? ModalWidth.NORMAL : ModalWidth.FULL}
      >
         <StyledFlex alignItems={'center'} direction={'column'} gap={12}>
            <StyledContent alignItems={'center'} direction={'column'} gap={12}>
               <MobilePhoneIcon />
               <Text as={'strong'} testId={'content'}>
                  <Translate>{t.content}</Translate>
               </Text>
               <Text testId={'liteVersionInformation'}>
                  <Translate>{t.liteVersionInformation}</Translate>
               </Text>
            </StyledContent>
            <StyledButtons alignItems={'center'} direction={'column'} gap={16}>
               <Separator />
               <Button
                  testId={'redirectToMobile'}
                  onClick={() => {
                     window.location.assign(mobileWebsiteUrl);
                  }}
                  label={t.actions.redirectToMobile}
                  variant={ButtonVariant.PRIMARY}
               />
               <Link testId={'stayOnDesktop'} onClick={closeModal} label={t.actions.stayOnDesktop} />
            </StyledButtons>
         </StyledFlex>
         <ModalCloseButton onClick={closeModal} />
      </Modal>
   );
};
